import styled from "styled-components";
export const TextAreaStyled = styled.textarea`
  resize: none;
  margin-top: 10px;
  margin-bottom: 10px;
  ::placeholder {
    font-size: 14px;
  }
  :focus {
    box-shadow: none;
  }
`;
